import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";
import {
  IOrderQueryRequestService,
  CHANNEL_ORDER_QUERY_REQUEST,
} from "../IOrderQueryRequestService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export abstract class OrderQueryRequestPromiseService implements IOrderQueryRequestService {
  abstract request(orderQuery: CubiqTS.OrderQueryRequest): Promise<CubiqTS.StandardReport>;
}
